const STYLES = {
  approved: "bg-green-50 text-green-700",
  rejected: "bg-red-50 text-red-700",
  pending: "bg-amber-50 text-amber-700",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`text-xs font-bold px-3 py-1.5 rounded-full self-center ${STYLES[status] || STYLES.pending}`}>
    {status}
  </span>
);
